import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getEachInvestments = async (id) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.EACH_INVESTMENT}/${Number(id)}`
  );
  return data;
};

export default function useEachInvestments(id) {
  return useQuery([id, "getEachInvestments"], getEachInvestments);
}
